import CustomResize from '../util/CustomResize';
import Collapsable from '../util/Collapsable';
// import Parallaxme from '../util/Parallaxme';
import HeadNav from '../components/HeadNav';
import Accordion from '../components/Accordion';
import CompaniesSearch from '../components/CompaniesSearch';
import CompaniesList from '../components/CompaniesList';
import CompaniesMap from '../components/CompaniesMap';
import '../components/CustomInputFile';
import '../components/CookieBanner';
import LabelForm from '../components/LabelForm';

export default {
  init() {
    // JavaScript to be fired on all pages

    /** Label form (any language / body class) */
    const labelForm = document.getElementById('label-form');
    if (labelForm && !labelForm.dataset.milLabelFormInit) {
      labelForm.dataset.milLabelFormInit = '1';
      new LabelForm(labelForm);
    }

    /** CustomResize window.resize handler */
    new CustomResize();

    /** Navigation button */
    new HeadNav();

    /** Initialize Accordion */
    new Accordion();

    window.addEventListener('load', () => {
      /** Initialize Parallaxme */
      // new Parallaxme('.para');

      /** Scroll top by header height if url has anchor to avoid header overlay over content */
      if (window.location.hash.indexOf('#') > -1) {
        if (!document.getElementById(window.location.hash.substr(1)).querySelector('.hr')) {
          setTimeout(() => {
            window.scrollTo(0, window.scrollY - document.getElementById('head').getBoundingClientRect().height);
          }, 500);
        }
      }

      /** Company search, list and map */
      (() => {
        const searchElt = document.getElementById('search');
        const resultsElt = document.getElementById('search-results');
        const detailsElt = document.getElementById('company-details');
        const companiesElt = document.getElementById('companies');
        const listElt = document.getElementById('companies-list');
        const navElt = document.getElementById('companies-nav');
        const mapButtonElt = document.getElementById('search-map-button');

        /** At least the search and the details elements are required */
        if (searchElt !== null && detailsElt !== null) {
          /** Initialize the CompaniesList only if the list and nav elements are present */
          const showCompaniesList = listElt !== null && navElt !== null;
          const companiesList = showCompaniesList ? new CompaniesList(companiesElt, listElt, detailsElt, navElt) : null;

          /** Initialize the CompaniesSearch */
          const search = new CompaniesSearch(searchElt, resultsElt, detailsElt, companiesList, 10, 2);

          /** Initialize the CompaniesMap only if the button element is present and if the CompaniesList exists */
          if (mapButtonElt !== null && companiesList !== null) {
            /** Initialize the CompaniesMap only if the Google maps api key is present */
            const apiKey = mapButtonElt.getAttribute('data-maps-api-key');
            if (apiKey !== null && apiKey.length > 0) {
              new CompaniesMap(apiKey, mapButtonElt, companiesList, search, detailsElt);
            }
          }
        }
      })();
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    /** Collapsable elements */
    window.collapsable = new Collapsable();
    window.collapsable.offsetElement = document.getElementById('head');

    /** Add .dev class to html tag for localhost */
    if (window.location.href.includes('localhost')) {
      document.querySelector('html').classList.add('dev');
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js